import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const BuilderEmployeeIcon = createIcon({
  displayName: 'BuilderEmployeeIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M3,21v-.47149a3,3,0,0,1,2.41165-2.94175l2.846-.56919a.90446.90446,0,0,1,.67911.13435h0a5.52237,5.52237,0,0,0,6.12652,0h0a.90446.90446,0,0,1,.67911-.13435l2.846.56919A3,3,0,0,1,21,20.52851V21"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="8"
        y1="21"
        x2="8"
        y2="17.06909"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="16"
        y1="21"
        x2="16"
        y2="17.06909"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M7.33484,9h9.33032a.5.5,0,0,0,.5-.5V7.16515A5.16515,5.16515,0,0,0,12,2h0A5.16515,5.16515,0,0,0,6.83484,7.16515V8.5A.5.5,0,0,0,7.33484,9Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="6.5"
        y1="9"
        x2="17.5"
        y2="9"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M16,9v2a4,4,0,0,1-4,4h0a4,4,0,0,1-4-4V9"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="14.10126"
        y1="14.40491"
        x2="14.82533"
        y2="17.30139"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="9.90123"
        y1="14.40491"
        x2="9.17719"
        y2="17.30127"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M13.5,2.22137V3.5A1.5,1.5,0,0,1,12,5h0a1.5,1.5,0,0,1-1.5-1.5V2.22137"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <rect width="24" height="24" fill="none" />
    </>
  ),
})

const BuilderEmployee: FC<IconProps> = (props) => {
  return <CustomIcon as={BuilderEmployeeIcon} {...props} />
}

export default memo(BuilderEmployee)
